export const fromDateToExcelSerialDate = (inDate: Date) => {
  const unixEpoch = '1900-01-01';
  const start = new Date(unixEpoch);
  // ! It is not working from the epoch Date so we need an adjustment in the number of days
  const adjustment = 2;
  const excelDate = Math.round((inDate.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)) + adjustment;
  return excelDate;
};
